<template>
    <div>
        <el-row>
            <el-col :span="24">
                <Head>
                    <template v-slot:title>
                        <span style="margin-left:30%;">企业认证</span>
                    </template>
                </Head>
            </el-col>
        </el-row>
        <el-row class="row-top" type="flex" justify="center">
            <el-col :span="15">
                <enterpriseList v-if="isShow" @statusFun="getStatus" :type="type"></enterpriseList>
                <enterpriseXq v-else @statusFun="getStatus" :item="itemData"></enterpriseXq>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import Head from '@/components/header/head.vue';
import enterpriseList from '@/components/audit/audit_list.vue';
import enterpriseXq from '@/views/audit/enterprise/enterprise_particulars.vue';
export default {
    data(){
        return {
            type:'0',

            isShow:true,
            // status:''
        }
    },
    methods:{
       getStatus(isShow,itemData){
        // console.log(isShow,itemData)
           this.isShow = isShow
           if(itemData){
               this.itemData = itemData
           }
       }
    },
    components:{
        Head,
        enterpriseList,
        enterpriseXq
    }
}
</script>
<style lang="less" scoped>

</style>
